import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import CommonDrawer from "../common/CommonDrawer";
import "./CategoryAdmin.css"; // reuse same admin UI css
import { toast } from "react-toastify";

function AdminPost() {
  const [posts, setPosts] = useState([]);
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);


  /* ---------- LOAD ---------- */
  const loadPosts = async () => {
    const res = await axiosInstance.get("/posts/");
    setPosts(res.data);
  };

  useEffect(() => {
    loadPosts();
  }, []);

  /* ---------- FORM ---------- */
  const resetForm = () => {
    setEditId(null);
    setContent("");
    setImage(null);
    setOpen(false);
  };

  const handleSubmit = async () => {
    if (!content && !image) {
      return toast.error("Add content or image");
    }

    const data = new FormData();
    data.append("content", content);
    if (image) data.append("image", image);

    try {
      setLoading(true);
      if (editId) {
        await axiosInstance.put(`/posts/?id=${editId}`, data);
      } else {
        await axiosInstance.post("/posts/", data);
      }
      resetForm();
      loadPosts();
    } catch {
      toast.error("Error saving post");
    } finally {
      setLoading(false);
    }
  };

  const editPost = (p) => {
    setEditId(p.id);
    setContent(p.content || "");
    setImage(null);
    setOpen(true);
  };

  const deletePost = async (id) => {
    if (window.confirm("Delete this post?")) {
      await axiosInstance.delete(`/posts/?id=${id}`);
      loadPosts();
    }
  };

  return (
    <div className="category-admin">
      <div className="header">
        <h2>Posts</h2>
        <button
          className="primary-btn"
          onClick={() => {
            resetForm();
            setOpen(true);
          }}
        >
          + Create Post
        </button>
      </div>

      {/* POSTS GRID */}
      <div className="posts-grid">
        {posts.map((p) => (
          <div className="post-card" key={p.id}>
            {p.image && (
              <img
  src={p.image}
  alt="post"
  className="post-image"
/>
            )}

            <div className="post-body">
              <p>{p.content}</p>

              <div className="actions">
                <button className="edit" onClick={() => editPost(p)}>
                  Edit
                </button>
                <button
                  className="danger"
                  onClick={() => deletePost(p.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* DRAWER */}
      <CommonDrawer
        open={open}
        title={editId ? "Edit Post" : "Create Post"}
        onClose={resetForm}
      >
        <textarea
          className="input"
          placeholder="Write a caption..."
          rows={3}
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />

        <input
          className="input"
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
        />

        {image && (
          <img
            src={URL.createObjectURL(image)}
            alt="preview"
            className="preview-image"
          />
        )}

        <button
          className="primary-btn full"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : editId ? "Update" : "Post"}
        </button>
      </CommonDrawer>
    </div>
  );
}

export default AdminPost;
